'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _paths = require('../../../actions/feiseanna/paths');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {

    case 'CREATE_GROUP_FEES':
      {
        return state.deleteIn([action.feis_id, 'loading']).updateIn([action.feis_id], function (groupFees) {
          return groupFees.push((0, _immutable.fromJS)(action.payload));
        });
      }

    case 'UPDATE_GROUP_FEES':
      {
        return state.deleteIn([action.feis_id, 'loading']).updateIn([action.feis_id], function (groupFees) {
          return groupFees.filter(function (g) {
            return g.get('id') !== action.id;
          }).push((0, _immutable.fromJS)(action.payload));
        });
      }

    case 'GET_GROUP_FEES_START':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ loading: true }));

    case 'GET_GROUP_FEES':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)(action.payload));

    case 'GET_GROUP_FEE':
      return state.updateIn([action.feis_id], function (groupFees) {
        return groupFees.filter(function (g) {
          return g.get('id') !== action.groupFee_id;
        }).push((0, _immutable.fromJS)(action.payload));
      });

    case 'GET_GROUP_FEES_ERROR':
      return state.deleteIn([action.feis_id, 'loading']);

    case 'DELETE_GROUP_FEES':
      {
        return state.deleteIn([action.feis_id, 'loading']).updateIn([action.feis_id], function (groupFees) {
          return groupFees.filter(function (g) {
            return g.get('id') !== action.id;
          });
        });
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/groupFees/index.js
// module id = 696
// module chunks = 0